/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_b2984092{display:block}.resizeIsShort_b2984092{width:400px}.buttonGroup_b2984092{margin-bottom:40px}.buttonGroup_b2984092 button{margin-right:20px}.settingsGroup_b2984092{padding-top:20px}.itemCountDropdown_b2984092{width:180px}\n"}]);
export const root = "root_b2984092";
export const resizeIsShort = "resizeIsShort_b2984092";
export const buttonGroup = "buttonGroup_b2984092";
export const settingsGroup = "settingsGroup_b2984092";
export const itemCountDropdown = "itemCountDropdown_b2984092";